import classNames from 'classnames';
import { forwardRef } from 'react';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import Blockquote from '@/shared/components/shared/Blockquote';
import Image from '@/shared/components/shared/Image';
import Responsive from '@/shared/components/shared/Responsive';
import { ImageShape } from '@/shared/lib/types';

type Props = React.HTMLAttributes<HTMLElement> & {
    properties: {
        name: string | null;
        position: string | null;
        image?: ImageShape | null;
        quote: string | null;
    };
};

const ConstructorQuote = forwardRef<HTMLDivElement, Props>(
    ({ properties: { name, image, quote, position }, ...props }, ref) => {
        const device = useMediaQueryDeviceStateValue();
        const isMobile = device.includes('mobile');
        return (
            <div
                {...props}
                ref={ref}
                className={classNames('constructor-block constructor-quote news-detail-wrapper', props.className)}
            >
                {!isMobile && image && (
                    <div className="blockquote-slide-inner">
                        <Responsive className="blockquote-img-wrapper">
                            <Image
                                className="blockquote-img"
                                src={image.src}
                                alt={image.alt || ''}
                                title={image.title}
                                width={image.width}
                                height={image.height}
                            />
                        </Responsive>
                    </div>
                )}
                <Blockquote
                    person={{
                        avatar: image,
                        name: name || '',
                        job: position || '',
                    }}
                    quote={quote || ''}
                />
            </div>
        );
    },
);

ConstructorQuote.displayName = 'ConstructorQuote';

export default ConstructorQuote;
